<div class="header-container container-fluid">
  <a *ngIf="!!externalLogoLink; else internalLogo" [href]="externalLogoLink">
    <ng-container *ngTemplateOutlet="imageLogo"></ng-container>
  </a>
  <ng-template #internalLogo>
    <a *ngIf="!!internalLogoRoute; else imageLogo" [routerLink]="internalLogoRoute">
      <ng-container *ngTemplateOutlet="imageLogo"></ng-container>
    </a>
  </ng-template>
  <ng-template #imageLogo>
    <img class="logo" src="/assets/images/pw_logo.svg" alt="logo">
  </ng-template>

  <pw-language-select></pw-language-select>
</div>